const Bus = {
    _events: {},
    dispatch: function(event, data) {
        if (!this._events[event]) {
            return;
        }
        for (let i = 0; i < this._events[event].length; i++) {
            this._events[event][i](data);
        }
        if (event === "forbidden") {
            this._unSubscribeAll();
        }
    },
    subscribe: function(event, callback) {
        if (!this._events[event]) {
            this._events[event] = [];
        }
        this._events[event].push(callback);
    },
    unSubscribe: function(eventArr) {
        if (eventArr && eventArr.length) {
            for (let i = 0; i < eventArr.length; i++) {
                delete this._events[eventArr[i]];
            }
        }
    },
    _unSubscribeAll: function() {
        this._events = {};
    }
};

export default Bus;
